import React from 'react';
import { Box } from '@material-ui/core';

interface ITabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
  className?: string;
}

export const TabPanel = (props: ITabPanelProps): JSX.Element => {
  const { children, value, index, ...other } = props;

  return (
    <Box hidden={value !== index} {...other} id={`tabpanel-${index}`} paddingTop={2}>
      {children}
    </Box>
  );
};
